import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M677.647059,733.705882 L677.647059,846.647059 L338.823529,846.647059 L338.823529,733.705882 L677.647059,733.705882 Z M1016.47059,507.823529 L1016.47059,620.764706 L338.823529,620.764706 L338.823529,507.823529 L1016.47059,507.823529 Z M1355.29412,733.705882 L1355.29412,169 L-2.5243549e-29,169 L-2.5243549e-29,1750.17647 L1920,1750.17647 L1920,733.705882 L1355.29412,733.705882 Z M1185.88235,1637.23529 C967.905882,1637.23529 790.588235,1459.91765 790.588235,1241.94118 C790.588235,1023.96471 967.905882,846.647059 1185.88235,846.647059 C1403.85882,846.647059 1581.17647,1023.96471 1581.17647,1241.94118 C1581.17647,1459.91765 1403.85882,1637.23529 1185.88235,1637.23529 L1185.88235,1637.23529 Z M1129.41176,965.325647 L1129.41176,1273.99388 L1340.61176,1477.62682 C1296.11294,1506.99153 1243.03059,1524.27153 1185.88235,1524.27153 C1030.13647,1524.27153 903.529412,1397.66447 903.529412,1241.91859 C903.529412,1105.59859 1000.65882,991.528 1129.41176,965.325647 L1129.41176,965.325647 Z M1242.35294,965.325647 C1371.10588,991.528 1468.23529,1105.59859 1468.23529,1241.91859 C1468.23529,1299.63153 1450.72941,1353.39153 1420.8,1398.11624 L1420.8,1398.11624 L1242.35294,1225.99388 Z M1468.23529,185.873412 C1468.23529,185.873412 1889.39294,581.280471 1903.17176,620.809882 L1903.17176,620.809882 L1468.23529,620.809882 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMsPptSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconMsPptSolid, _Component);

  var _super = _createSuper(IconMsPptSolid);

  function IconMsPptSolid() {
    _classCallCheck(this, IconMsPptSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconMsPptSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMsPpt",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMsPptSolid.displayName = "IconMsPptSolid";
  return IconMsPptSolid;
}(Component);

IconMsPptSolid.glyphName = 'ms-ppt';
IconMsPptSolid.variant = 'Solid';
IconMsPptSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMsPptSolid;
export { IconMsPptSolid };